import CarePage from "@page-containers/get-care/[slug]";

export default CarePage;
